import { groupCategoryRequest } from "@/service/groupManage";
import { debug, log } from "console";


// 用户有多个分组的形式时过滤显示分组树
export const filterMultipleCateData = (data: any, cateIds: any) => {
  const newData: any = [];
  data.forEach((item: any) => {
    let obj: any = {};
    if (cateIds.includes(item.id)) {
      newData.push(item);
    } else if (Array.isArray(item.children) && item.children.length > 0) {
      const tempData = filterMultipleCateData(item.children, cateIds);
      obj = {
        ...item,
        children: tempData,
      };
      // 当children不为空时才保留该数据
      if (obj.children.length > 0) {
        newData.push(obj);
      }
    }
  });
  return newData;
};





/**
 * 根据用户权限处理CateId父节点问题
 * 之前存在的问题是如果一个父节点存在abc三个子项，但是某一用户只有ab的权限，那么在实际使用中他选择a、b两个子项的时候前端就视为全选当前父节点，
 * 会直接传父节点Id。而这个操作会让后端错误的处理当前父节点的所有子节点而无视权限。
 */

export const cateNodeHandlerGen = async () => {
  const _getCateIdsFromLocalStorage = () => {
    const userDetailStr = localStorage.getItem('userDetail');
    if (userDetailStr) {
      const userDetail = JSON.parse(userDetailStr);
      return userDetail.cateIdArr || [];
    }
    return [];
  };
  // 获取分组树形数据
  const _getCategoryData = async () => {
    const res = await groupCategoryRequest();
    return res.data?.data || [];
  }
  // 根据ID查找对应的分组节点
  const _findNodeById = (nodes: CateNode[], targetId: number): CateNode | null => {
    for (const node of nodes) {
      if (node.id === targetId) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = _findNodeById(node.children, targetId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  // 递归获取节点下所有在用户权限内的子节点ID
  const _getAuthorizedChildIds = (node: CateNode): number[] => {
    const childIds: number[] = [];

    if (userCateIds.includes(node.id)) {
      childIds.push(node.id);
    }

    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        childIds.push(..._getAuthorizedChildIds(child));
      }
    }

    return childIds;
  };
  //获取用户当前权限可以浏览的cateID
  const userCateIds = _getCateIdsFromLocalStorage();
  //获取所有cateId
  const _allCateIds = await _getCategoryData();
  const allCateIds: CateNode[] = userCateIds.length > 1 ? filterMultipleCateData(_allCateIds, userCateIds) : _allCateIds;

  // 获取一个节点下所有叶子节点的ID
  const _getAllLeafIds = (node: CateNode): number[] => {
    // 如果是叶子节点，直接返回自身ID
    if (!node.children || node.children.length === 0) {
      return [node.id];
    }
    
    // 如果是父节点，递归获取所有叶子节点ID
    let leafIds: number[] = [];
    for (const child of node.children) {
      leafIds = leafIds.concat(_getAllLeafIds(child));
    }
    return leafIds;
  };

  //获取所有平铺的id
  const _getAllCateIds = (nodes: CateNode[], parentInUserCateIds: boolean = false): number[] => {
    let ids: number[] = [];
    for (const node of nodes) {
      // 如果是叶子节点，直接push
      if (!node.children || node.children.length === 0) {
        ids.push(node.id);
      } else {
        // 检查当前父节点是否在userCateIds中
        const currentNodeInUserCateIds = userCateIds.includes(node.id);
        
        // 如果父节点本身在userCateIds中，直接push
        if (currentNodeInUserCateIds) {
          ids.push(node.id);
        }
        // 如果当前父节点不在userCateIds中，但是往上的父节点在userCateIds中，也push
        else if (parentInUserCateIds) {
          ids.push(node.id);
        }
        // 如果以上都不满足，则检查所有叶子节点是否都在userCateIds中
        else {
          const leafIds = _getAllLeafIds(node);
          const allLeafInUserCateIds = leafIds.every(leafId => userCateIds.includes(leafId));
          
          // 如果所有叶子节点都在userCateIds中，则添加当前父节点ID
          if (allLeafInUserCateIds) {
            ids.push(node.id);
          }
        }
      }
      
      // 无论是否push当前节点，都继续处理子节点
      if (node.children && node.children.length > 0) {
        const childParentInUserCateIds = userCateIds.includes(node.id) || parentInUserCateIds;
        ids = ids.concat(_getAllCateIds(node.children, childParentInUserCateIds));
      }
    }
    return ids;
  };
  const allFlatCateIds = _getAllCateIds(_allCateIds);
  const _cateIdHandler = (ids: number[]) => {
    const res: number[] = [];
    
    for (const id of ids) {
      //如果id在用户权限（userCateIds）内，则直接添加
      if (allFlatCateIds.includes(id)) {
        res.push(id);
      }
      //如果不在用户权限内，则开始遍历id对应的节点的children，
      // 把所有在用户权限（userCateIds）内的子节点加入结果，
      // 如果不在且不含children的直接丢弃，
      // 如果不在且包含children的则对其id对应的CateNode递归调用这个方法
      else {
        const node = _findNodeById(allCateIds, id);
        if (node) {
          // 如果找到节点且有children，则获取所有在权限内的子节点
          if (node.children && node.children.length > 0) {
            const authorizedChildIds = _getAuthorizedChildIds(node);
            res.push(...authorizedChildIds.filter(childId => !res.includes(childId)));
          }
          // 如果节点不在权限内且没有children，则直接丢弃（不做任何操作）
        }
      }
    }
    return res;
  };


  return _cateIdHandler;
}



/****** 类型，估计别的地方也用我懒得换地方了就写这吧 */
type CateNode = {
  id: number;
  title: string;
  children?: CateNode[];
}